import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: var(--t-brand-bg-color);
`;

export const SubheaderWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
`;

export const ButtonWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-left: 1rem;
`;
